import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useUserStore } from 'hooks/stores/useUserStore';
import { ASSET_PREFIX } from 'utils/constants';
import ChangeEmailPopup from 'components/enter/ChangeEmailPopup';
import React from 'react';

interface IEmailValidationMessage {
  style?: React.CSSProperties;
  email?: string;
}

const EmailValidationMessage = observer(
  ({ style = undefined, email = undefined }: IEmailValidationMessage) => {
    const { currentUser, currentGuestUser } = useUserStore();

    const [showChangeEmailPopup, setShowChangeEmailPopup] = useState(false);

    const doNotShowForCurrentUser =
      !currentUser ||
      !currentUser.emailAddress ||
      !email ||
      currentUser.hasSocialLogin;
    const doNotShowForCurrentGuestUser =
      !currentGuestUser ||
      !currentGuestUser.emailAddress ||
      currentGuestUser.usesThirdPartyAuth;

    if (doNotShowForCurrentUser && doNotShowForCurrentGuestUser) return null;

    const currentEmailAddress = doNotShowForCurrentUser
      ? currentGuestUser?.emailAddress
      : currentUser.emailAddress;

    return (
      <div
        className="container"
        style={style}
      >
        <img
          src={`${ASSET_PREFIX}/images/account/email-preferences.svg`}
          alt=""
          style={{
            width: 50,
            height: 50,
            marginRight: 20,
          }}
        />
        <div className="textContainer">
          <p>
            We'll email you at{' '}
            <span style={{ fontWeight: 800 }}>{currentEmailAddress}</span>
          </p>
          <p style={{ fontStyle: 'italic', fontWeight: 700 }}>
            Not correct? {''}
            <button onClick={() => setShowChangeEmailPopup(true)}>
              Change email
            </button>
          </p>
        </div>

        {showChangeEmailPopup && (
          <ChangeEmailPopup
            currentEmailAddress={currentEmailAddress!}
            onClose={() => setShowChangeEmailPopup(false)}
          />
        )}

        <style jsx>
          {`
            .container {
              background-color: #f6f6f6;
              border-radius: 10px;
              padding: 2em;
              display: flex;
              align-items: center;
            }

            .container button {
              padding: unset;
              background-color: transparent;
              color: inherit;
              font-weight: 800;
              font-style: italic;
              text-decoration: underline;
            }
          `}
        </style>
      </div>
    );
  }
);

export default EmailValidationMessage;
